import { ParticipantDetails } from "./../models/userDetails";

const handleGetCampaginCode = ()=>{

    return "CTC_FREO_GENERIC_QA_3";
    // switch(ParticipantDetails.getInstance().getPartnerDetails().partnerCode){
    //     case "TAPSTART":
    //         return "CTC_TAPSTART_1600_1";
    //     default:
    //         return "CTC_FREO_GENERIC_1";
    // }
}

export {
    handleGetCampaginCode
}